module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-249.f5ed3de7.svg";